import { IHisItemParameterBean } from "./beans";
import { HisItemParameter } from "../../../domain/his/behavior/HisItemParameter";

export class HisItemParameterTranslator {
  static toHisItemParameter(bean: IHisItemParameterBean): HisItemParameter {
    if (!bean) { return null; }
    const param = new HisItemParameter();
    param.key = bean.key;
    param.displayName = bean.displayName;
    param.screenKind = bean.screenType;
    param.informationKind = bean.informationType;
    param.reloadKind = bean.reloadType;
    param.updateTimingKind = bean.setPlaceType;
    param.objectKind = bean.objectType;
    param.isMultiSelect = !!bean.isMultiSelect;
    param.reloadDetailKind = bean.reloadDetailType;
    if (bean.key === "INTRO_HOSP_DESTINATION_PACKAGE" || bean.key === "INTRO_HOSP_DESTINATION_PACKAGE2") {
      param.isInstitutionSelect = true;
    }
    return param;
  }
}
